module.exports = __webpack_public_path__ + "img/l100.5d93bab2.png";